export default {
	ataMenu: 'AtaRegistroPreco.Ata.Menu',
	ataEfetivar: 'AtaRegistroPreco.Ata.Efetivar',
	ataListar: 'AtaRegistroPreco.Ata.Listar',
	processoUtilizacaoListar: 'AtaRegistroPreco.ProcessoUtilizacao.Listar',
	ataEditar: 'AtaRegistroPreco.Ata.Editar',
	ataExcluir: 'AtaRegistroPreco.Ata.Excluir',
	ataVisualizar: 'AtaRegistroPreco.Ata.Visualizar',
	ataOrgaosParticipantes: 'AtaRegistroPreco.Ata.OrgaosParticipantes',
	ataBloquear: 'AtaRegistroPreco.Ata.Bloquear',
	ataCancelar: 'AtaRegistroPreco.Ata.Cancelar',
	ataDesbloquear: 'AtaRegistroPreco.Ata.Desbloquear',
	ataNumeroAtaEditar: 'AtaRegistroPreco.Ata.NumeroAta.Editar',
	ataHistoricoBloqueioListar: 'AtaRegistroPreco.Ata.Historico.Bloqueio.Listar',
	ataComProcessoCriar: 'AtaRegistroPreco.Ata.ComProcesso.Criar',
	ataImportarQuantitativo: 'AtaRegistroPreco.Ata.importarQuantitativo',
	ataDocumentoListar: 'AtaRegistroPreco.Ata.Documento.Listar',
	ataDocumentoExcluir: 'AtaRegistroPreco.Ata.Documento.Excluir',
	ataDocumentoBaixar: 'AtaRegistroPreco.Ata.Documento.Baixar',
	ataDocumentoSincronizarAreaPublica: 'AtaRegistroPreco.Ata.Documento.SincronizarAreaPublica',
	ataProcessoDigitalJuntarLote: 'AtaRegistroPreco.Ata.Documento.ProcessoDigital.JuntarEmLote',
	ataAssinaturaEletronicaCriar: 'AtaRegistroPreco.Ata.Documento.ProcessoDigital.AssinaturaEletronica.Criar',
	ataAssinaturaDigitalCriar: 'AtaRegistroPreco.Ata.Documento.ProcessoDigital.AssinaturaDigital.Criar',
	ataAssinaturaValidar: 'AtaRegistroPreco.Ata.Documento.ProcessoDigital.Assinatura.Validar',
	ataEditorTextoSincronizar: 'AtaRegistroPreco.Ata.Documento.EditorTexto.Sincronizar',
	ataEditorTextoRedigir: 'AtaRegistroPreco.Ata.Documento.EditorTexto.Redigir',
	ataEditorTextoVisualizar: 'AtaRegistroPreco.Ata.Documento.EditorTexto.Visualizar',
	ataEditorTextoCriar: 'AtaRegistroPreco.Ata.Documento.EditorTexto.Criar',
	ataIntegracaoDetalhamentoEnviar: 'AtaRegistroPreco.Integracao.Detalhamento.Ata.Enviar',
	adesaoIntegracaoDetalhamentoEnviar: 'AtaRegistroPreco.Integracao.Detalhamento.Adesao.Enviar',
	ataParteEnvolvidaListar: 'AtaRegistroPreco.Ata.ParteEnvolvida.Listar',
	ataParteEnvolvidaCriar: 'AtaRegistroPreco.Ata.ParteEnvolvida.Criar',
	ataAdesaoBuscarOrgaos: 'AtaRegistroPreco.Ata.Adesao.BuscarOrgao',
	ataAdesaoCriar: 'AtaRegistroPreco.Ata.Adesao.Criar',
	ataAdesaoExcluir: 'AtaRegistroPreco.Ata.Adesao.Excluir',
	ataAdesaoEditar: 'AtaRegistroPreco.Ata.Adesao.Editar',
	ataAdesaoJustificativaEditar: 'AtaRegistroPreco.Ata.Adesao.Justificativa.Editar',
	ataAdesaoNumeroProcessoEditar: 'AtaRegistroPreco.Ata.Adesao.NumeroProcesso.Editar',
	ataAdesaoDoeEditar: 'AtaRegistroPreco.Ata.Adesao.Doe.Editar',
	ataAdesaoItemInserir: 'AtaRegistroPreco.Ata.Adesao.Item.Inserir',
	ataAdesaoItemEditar: 'AtaRegistroPreco.Ata.Adesao.Item.Editar',
	ataAdesaoItemVinculadosListar: 'AtaRegistroPreco.Adesao.Itens.Vinculados.Listar',
	ataAdesaoItemExcluir: 'AtaRegistroPreco.Ata.Adesao.Item.EmRascunho.Excluir',
	ataAdesaoDocumentoAdicionar: 'AtaRegistroPreco.Ata.Adesao.Documento.EditorTexto.Criar',
	ataAdesaoAnexoAdicionar: 'AtaRegistroPreco.Ata.Adesao.Documento.Anexo.Criar',
	ataAdesaoDocumentoRedigir: 'AtaRegistroPreco.Ata.Adesao.Documento.EditorTexto.Redigir',
	ataAdesaoDocumentoConcluirEdicao: 'AtaRegistroPreco.Ata.Adesao.Documento.EditorTexto.Sincronizar',
	ataAdesaoDocumentoAssinaturaEletronicaCriar:
		'AtaRegistroPreco.Ata.Adesao.Documento.ProcessoDigital.AssinaturaEletronica.Criar',
	ataAdesaoDocumentoAssinaturaDigitalCriar:
		'AtaRegistroPreco.Ata.Adesao.Documento.ProcessoDigital.AssinaturaDigital.Criar',
	ataAdesaoJuntarDocumento: 'AtaRegistroPreco.Ata.Adesao.Documento.ProcessoDigital.JuntarEmLote',
	ataAdesaoDocumentoExcluir: 'AtaRegistroPreco.Ata.Adesao.Documento.Excluir',
	ataAdesaoDocumentoConvidarSignatarios: 'AtaRegistroPreco.Ata.Adesao.Documento.convidarSignatarios',
	ataAdesaoDocumentoDesentranharCriar:
		'AtaRegistroPreco.Adesao.Documento.ProcessoDigital.TermoDesentranhamento.Criar',
	ataAdesaoListar: 'AtaRegistroPreco.Ata.Adesao.Listar',
	ataAdesaoDocumentoDesentranharEditar:
		'AtaRegistroPreco.Adesao.Documento.ProcessoDigital.TermoDesentranhamento.Editar',
	ataAdesaoDocumentoBaixar: 'AtaRegistroPreco.Ata.Adesao.Documento.Baixar',
	ataAdesaoDocumentoCancelar: 'AtaRegistroPreco.Ata.Adesao.Documento.ProcessoDigital.Cancelar',
	ataAdesaoDocumentoPncpEnviar: 'AtaRegistroPreco.Ata.Adesao.Documento.Pncp.Enviar',
	ataAdesaoDocumentoPncpExcluir: 'AtaRegistroPreco.Ata.Adesao.Documento.Pncp.Excluir',
	ataAdesaoAceitar: 'AtaRegistroPreco.Ata.Adesao.Aceitar',
	ataAdesaoConcluir: 'AtaRegistroPreco.Ata.Adesao.Concluir',
	ataAdesaoRecusar: 'AtaRegistroPreco.Ata.Adesao.Recusar',
	ataAdesaoItemEstornar: 'AtaRegistroPreco.Adesao.Item.Estornar',
	ataAdesaoProcessoDigitalVisualizar: 'AtaRegistroPreco.Ata.Adesao.ProcessoDigital.Visualizar',
	ataAdesaoEnviarIntegracao: 'AtaRegistroPreco.Adesao.Integracao.Enviar',
	ataAdesaoGerarRelatorioPrevio: 'AtaRegistroPreco.Ata.Adesao.GerarRelatorioPrevio',
	ataProrrogacao: 'AtaRegistroPreco.Ata.Prorrogacao',
	ataProrrogacaoListar: 'AtaRegistroPreco.Ata.Prorrogacao.Listar',
	ataProrrogacaoExcluir: 'AtaRegistroPreco.Ata.Prorrogacao.Excluir',
	ataOcorrenciaListar: 'AtaRegistroPreco.Ata.Ocorrencia.Listar',
	ataOcorrenciaEditar: 'AtaRegistroPreco.Ata.Ocorrencia.Editar',
	ataOcorrenciaExcluir: 'AtaRegistroPreco.Ata.Ocorrencia.Excluir',
	ataOcorrenciaRespostaCriar: 'AtaRegistroPreco.Ata.Ocorrencia.Resposta.Criar',
	ataOcorrenciaRespostaEditar: 'AtaRegistroPreco.Ata.Ocorrencia.Resposta.Editar',
	ataOcorrenciaRespostaListar: 'AtaRegistroPreco.Ata.Ocorrencia.Resposta.Listar',
	ataOcorrenciaRespostaExcluir: 'AtaRegistroPreco.Ata.Ocorrencia.Resposta.Excluir',
	ataFiscal: 'AtaRegistroPreco.Ata.Fiscais',
	ataFiscaisListar: 'AtaRegistroPreco.Ata.Fiscais.Listar',
	ataFiscaisCriar: 'AtaRegistroPreco.Ata.Fiscais.Criar',
	ataFiscaisExcluir: 'AtaRegistroPreco.Ata.Fiscais.Excluir',
	ataPenalidadesListar: 'AtaRegistroPreco.Ata.Penalidade.Listar',
	ataPenalidadesCriar: 'AtaRegistroPreco.Ata.Penalidade.Criar',
	ataPenalidadesEditar: 'AtaRegistroPreco.Ata.Penalidade.Editar',
	ataPenalidadesExcluir: 'AtaRegistroPreco.Ata.Penalidade.Excluir',
	ataPenalidadesVisualizar: 'AtaRegistroPreco.Ata.Penalidade.Visualizar',
	ataPenalidadesBaixarAnexo: 'AtaRegistroPreco.Ata.Penalidade.Documento.Baixar',
	ataPenalidadesHistoricoNotificacoes: 'AtaRegistroPreco.Ata.Penalidade.Notificacoes.Historico',
	ataAcompanhamentoSaldo: 'AtaRegistroPreco.Ata.Acompanhamento.Saldo',
	verificarItensPendentes: 'AtaRegistroPreco.Ata.Adesao.PossuiItensPendentes',
	itemProcessoEditalListar: 'AtaRegistroPreco.ItemProcesso.Edital.Listar',
	itemProcessoPorFornecedorListar: 'AtaRegistroPreco.ItemProcesso.PorFornecedor.Listar',
	itemProcessoListar: 'AtaRegistroPreco.ItemProcesso.Listar',
	itemAtaRealinhar: 'AtaRegistroPreco.ItemAta.Realinhar',
	itemAtaExcluir: 'AtaRegistroPreco.ItemAta.Excluir',
	itemAtaListar: 'AtaRegistroPreco.ItemAta.Listar',
	itemAtaComProcessoCriar: 'AtaRegistroPreco.ItemAta.ComProcesso.Criar',
	itemAtaBloquear: 'AtaRegistroPreco.ItemAta.Bloquear',
	itemAtaDesbloquear: 'AtaRegistroPreco.ItemAta.Desbloquear',
	itemAtaHistoricoBloqueioListar: 'AtaRegistroPreco.ItemAta.Historico.Bloqueio.Listar',
	itemAtaAditar: 'AtaRegistroPreco.ItemAta.Aditar',
	itemAtaHistoricoAditarListar: 'AtaRegistroPreco.ItemAta.Historico.Aditamento.Listar',
	itemAtaHistoricoRealinhamentoListar: 'AtaRegistroPreco.ItemAta.Historico.Realinhamento.Listar',
	itemAtaAlterarFornecedor: 'AtaRegistroPreco.ItemAta.AlterarFornecedor',
	itemAtaHistoricoAlteracaoFornecedorListar: 'AtaRegistroPreco.ItemAta.Historico.AlteracaoFornecedor.Listar',
	itemAtaAlterarClassificacao: 'AtaRegistroPreco.ItemAta.AlterarClassificacao',
	itemAtaSaldoTransferir: 'AtaRegistroPreco.ItemAta.Saldo.Transferir',
	itemAtaHistoricoAlteracaoClassificacaoListar: 'AtaRegistroPreco.ItemAta.Historico.AlteracaoClassificacao.Listar',
	fornecedorItemListar: 'AtaRegistroPreco.FornecedorItem.Listar',
	fornecedorItemAtaListar: 'AtaRegistroPreco.FornecedorItemAta.Listar',
	fornecedorItemAtaTodosListar: 'AtaRegistroPreco.FornecedorItemAta.Todos.Listar',
	fornecedorItemAtaPrincipalComAderentesListar: 'AtaRegistroPreco.FornecedorItemAta.PrincipalComAderentes.Listar',
	pessoaFiliaisListar: 'AtaRegistroPreco.Pessoa.Filiais.Listar',
	loteDoFornecedorListar: 'AtaRegistroPreco.Lote.DoFornecedor.Listar',
	loteListar: 'AtaRegistroPreco.Lote.Listar',
	arquivosTemporariosCriar: 'AtaRegistroPreco.ArquivosTemporarios.Criar',
	ataDocumentoAnexoCriar: 'AtaRegistroPreco.Ata.Documento.Anexo.Criar',
	modeloDocumentoListarAtivos: 'AtaRegistroPreco.ModeloDocumento.ListarAtivos',
	modeloDocumentoEditar: 'AtaRegistroPreco.ModeloDocumento.Editar',
	modeloDocumentoVisualizar: 'AtaRegistroPreco.ModeloDocumento.Visualizar',
	modeloDocumentoExcluir: 'AtaRegistroPreco.ModeloDocumento.Excluir',
	modeloDocumentoListar: 'AtaRegistroPreco.ModeloDocumento.Listar',
	modeloDocumentoCriar: 'AtaRegistroPreco.ModeloDocumento.Criar',
	modeloDocumentoRedigir: 'AtaRegistroPreco.ModeloDocumento.Redigir',
	modeloDocumentoVisualizarConteudo: 'AtaRegistroPreco.ModeloDocumento.VisualizarConteudo',
	tipoDocumentoCriar: 'AtaRegistroPreco.TipoDocumento.Criar',
	tipoDocumentoListar: 'AtaRegistroPreco.TipoDocumento.Listar',
	tipoDocumentoEditar: 'AtaRegistroPreco.TipoDocumento.Editar',
	tipoDocumentoExcluir: 'AtaRegistroPreco.TipoDocumento.Excluir',
	tipoDocumentoValidacaoTramitacaoListar: 'AtaRegistroPreco.TipoDocumento.ValidacaoTramitacao.Listar',
	tipoDocumentoValidacaoTramitacaoCriar: 'AtaRegistroPreco.TipoDocumento.ValidacaoTramitacao.Criar',
	tipoDocumentoValidacaoTramitacaoEditar: 'AtaRegistroPreco.TipoDocumento.ValidacaoTramitacao.Editar',
	tipoDocumentoValidacaoTramitacaoExcluir: 'AtaRegistroPreco.TipoDocumento.ValidacaoTramitacao.Excluir',
	processoVisualizar: 'AtaRegistroPreco.Processo.Vizualizar',
	processoListar: 'AtaRegistroPreco.Processo.Listar',
	gerarRelatorio: 'AtaRegistroPreco.Relatorio.Gerar',
	configuracoesMenu: 'AtaRegistroPreco.Configuracoes.Menu',
	modeloDocumentoMenu: 'AtaRegistroPreco.ModeloDocumento.Menu',
	tipoDocumentoMenu: 'AtaRegistroPreco.TipoDocumento.Menu',
	editorTextoListar: 'AtaRegistroPreco.Ata.Documento.Listar',
	assinaturaEletronicaLoteCriar: 'AtaRegistroPreco.Ata.Documento.ProcessoDigital.AssinaturaEletronica.Criar',
	baixarDownloadImpressao: 'AtaRegistroPreco.Ata.Documento.ProcessoDigital.Baixar.Impressao',
	ataDocumentoProcessoDigitalCancelar: 'AtaRegistroPreco.Ata.Documento.ProcessoDigital.Cancelar',
	processoDigitalTermoDesentranhamentoCriar:
		'AtaRegistroPreco.Ata.Documento.ProcessoDigital.TermoDesentranhamento.Criar',
	processoDigitalTermoDesentranhamentoEditar:
		'AtaRegistroPreco.Ata.Documento.ProcessoDigital.TermoDesentranhamento.Editar',
	documentoProcessoDigitalVisualizar: 'AtaRegistroPreco.Ata.Documento.ProcessoDigital.Visualizar',
	pedidoUtilizacaoPorProcessoListar: 'AtaRegistroPreco.PedidoUtilizacao.PorProcesso.Listar',
	pedidoUtilizacaoDocumentoListar: 'AtaRegistroPreco.PedidoUtilizacao.Documento.Listar',
	pedidoUtilizacaoDocumentoAnexoCriar: 'AtaRegistroPreco.PedidoUtilizacao.Documento.Anexo.Criar',
	pedidoUtilizacaoDocumentoEditorTextoCriar: 'AtaRegistroPreco.PedidoUtilizacao.Documento.EditorTexto.Criar',
	pedidoUtilizacaoDocumentoEditorTextoRedigir: 'AtaRegistroPreco.PedidoUtilizacao.Documento.EditorTexto.Redigir',
	pedidoUtilizacaoDocumentoEditorTextoVisualizar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.EditorTexto.Visualizar',
	pedidoUtilizacaoDocumentoExcluir: 'AtaRegistroPreco.PedidoUtilizacao.Documento.Excluir',
	pedidoUtilizacaoDocumentoBaixar: 'AtaRegistroPreco.PedidoUtilizacao.Documento.Baixar',
	pedidoUtilizacaoDocumentoConvidarSignatarios: 'AtaRegistroPreco.PedidoUtilizacao.Documento.convidarSignatarios',
	pedidoUtilizacaoDocumentoEnviarFornecedor: 'AtaRegistroPreco.PedidoUtilizacao.Documento.EnviarFornecedor',
	pedidoUtilizacaoProcessoDigitalTermoDesentranhamentoCriar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.TermoDesentranhamento.Criar',
	pedidoUtilizacaoDocumentoProcessoDigitalVisualizar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.Visualizar',
	pedidoUtilizacaoDocumentoProcessoDigitalAssinaturaDigitalCriar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.AssinaturaDigital.Criar',
	pedidoUtilizacaoDocumentoProcessoDigitalAssinaturaEletronicaCriar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.AssinaturaEletronica.Criar',
	pedidoUtilizacaoDocumentoProcessoDigitalAssinaturaValidar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.Assinatura.Validar',
	pedidoUtilizacaoDocumentoProcessoDigitalCancelar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.Cancelar',
	pedidoUtilizacaoDocumentoProcessoDigitalBaixarImpressao:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.Baixar.Impressao',
	pedidoUtilizacaoDocumentoProcessoDigitalTermoDesentranhamentoEditar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.TermoDesentranhamento.Editar',
	pedidoUtilizacaoPedidoUtilizacaoNumeroProcessoListar: 'AtaRegistroPreco.PedidoUtilizacao.NumeroProcesso.Listar',
	pedidoUtilizacaoNumeroEmpenhoEditar: 'AtaRegistroPreco.PedidoUtilizacao.NumeroEmpenho.Editar',
	pedidoUtilizacaoPedidoUtilizacaoConcluir: 'AtaRegistroPreco.PedidoUtilizacao.Concluir',
	pedidoUtilizacaoedidoUtilizacaoAutorizar: 'AtaRegistroPreco.PedidoUtilizacao.Autorizar',
	pedidoUtilizacaoProcessoDigitalVisualizar: 'AtaRegistroPreco.PedidoUtilizacao.ProcessoDigital.Visualizar',
	pedidoUtilizacaoEfetivar: 'AtaRegistroPreco.PedidoUtilizacao.Efetivar',
	pedidoUtilizacaoDocumentoProcessoDigitalAssinaturaEletronicaLoteIniciar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.AssinaturaEletronica.Lote.Iniciar',
	pedidoUtilizacaoDocumentoProcessoDigitalJuntarEmLote:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.ProcessoDigital.JuntarEmLote',
	pedidoUtilizacaoDocumentoEditorTextoSincronizar:
		'AtaRegistroPreco.PedidoUtilizacao.Documento.EditorTexto.Sincronizar',
	pedidoUtilizacaoOrgaoDoUsuarioListar: 'AtaRegistroPreco.PedidoUtilizacao.Orgao.DoUsuario.Listar',
	pedidoUtilizacaoTemRascunho: 'AtaRegistroPreco.PedidoUtilizacao.TemRascunho',
	pedidoUtilizacaoRascunhoCriar: 'AtaRegistroPreco.PedidoUtilizacao.Rascunho.Criar',
	pedidoUtilizacaoEditar: 'AtaRegistroPreco.PedidoUtilizacao.Editar',
	pedidoUtilizacaoNumeroPedidoEditar: 'AtaRegistroPreco.PedidoUtilizacao.NumeroPedido.Editar',
	pedidoUtilizacaoItemEditar: 'AtaRegistroPreco.PedidoUtilizacao.Item.Editar',
	pedidoUtilizacaoItemEmRascunhoExcluir: 'AtaRegistroPreco.PedidoUtilizacao.Item.EmRascunho.Excluir',
	pedidoUtilizacaoItemDisponivelListar: 'AtaRegistroPreco.PedidoUtilizacao.Item.Disponivel.Listar',
	pedidoUtilizacaoItemUnidadeDespesaEditar: 'AtaRegistroPreco.PedidoUtilizacao.Item.UnidadeDespesa.Editar',
	pedidoUtilizacaoItemListar: 'AtaRegistroPreco.PedidoUtilizacao.Item.Listar',
	pedidoUtilizacaoItemQtdSolicitadaEditar: 'AtaRegistroPreco.PedidoUtilizacao.Item.QtdSolicitada.Editar',
	pedidoUtilizacaoItemExcluir: 'AtaRegistroPreco.PedidoUtilizacao.Item.Excluir',
	pedidoUtilizacaoVisualizar: 'AtaRegistroPreco.PedidoUtilizacao.Visualizar',
	pedidoUtilizacaoExcluir: 'AtaRegistroPreco.PedidoUtilizacao.Excluir',
	pedidoUtilizacaoItemEstornar: 'AtaRegistroPreco.PedidoUtilizacao.Item.Estornar',
	pedidoUtilizacaoIntegracaoEnviar: 'AtaRegistroPreco.PedidoUtilizacao.Integracao.Enviar',
	pedidoUtilizacaoGerarRelatorioPrevio: 'AtaRegistroPreco.PedidoUtilizacao.GerarRelatorioPrevio',
	pedidoUtilizacaoFiscal: 'AtaRegistroPreco.PedidoUtilizacao.Fiscais',
	pedidoUtilizacaoPenalidadesListar: 'AtaRegistroPreco.PedidoUtilizacao.Penalidade.Listar',
	pedidoUtilizacaoPenalidadesVisualizar: 'AtaRegistroPreco.PedidoUtilizacao.Penalidade.Visualizar',
	pedidoUtilizacaoPenalidadesCriar: 'AtaRegistroPreco.PedidoUtilizacao.Penalidade.Criar',
	pedidoUtilizacaoPenalidadesEditar: 'AtaRegistroPreco.PedidoUtilizacao.Penalidade.Editar',
	pedidoUtilizacaoPenalidadesExcluir: 'AtaRegistroPreco.PedidoUtilizacao.Penalidade.Excluir',
	pedidoUtilizacaoPenalidadesBaixarAnexo: 'AtaRegistroPreco.PedidoUtilizacao.Penalidade.Documento.Baixar',
	pedidoUtilizacaoPenalidadesHistoricoNotificacoes:
		'AtaRegistroPreco.PedidoUtilizacao.Penalidade.Notificacoes.Historico',
	dotacaoOrcamentariaElementoSubElementoVisualizar:
		'AtaRegistroPreco.DotacaoOrcamentaria.ElementoSubElemento.Visualizar',
	dotacaoOrcamentariaOrgaosVisualizar: 'AtaRegistroPreco.DotacaoOrcamentaria.Orgaos.Visualizar',
	dotacaoOrcamentariaVisualizar: 'AtaRegistroPreco.DotacaoOrcamentaria.Visualizar',
	pedidoUtizacaoDotacaoOrcamentariaVisualizar: 'AtaRegistroPreco.PedidoUtilizacao.DotacaoOrcamentaria.Visualizar',
	pedidoUtizacaoDotacaoOrcamentariaCriar: 'AtaRegistroPreco.PedidoUtilizacao.DotacaoOrcamentaria.Criar',
	pedidoUtizacaoDotacaoOrcamentariaEditar: 'AtaRegistroPreco.PedidoUtilizacao.DotacaoOrcamentaria.Editar',
	pedidoUtizacaoDotacaoOrcamentariaExcluir: 'AtaRegistroPreco.PedidoUtilizacao.DotacaoOrcamentaria.Excluir',
	relatorioPersonalizadoMenu: 'AtaRegistroPreco.Relatorio.Personalizado.Menu',
	relatorioControleAdesoes: 'AtaRegistroPreco.Menu.Relatorio.ControleAdesoes',
	relatorioControleSaldos: 'AtaRegistroPreco.Menu.Relatorio.ControleSaldos',
	aditivoApostilaCriar: 'AtaRegistroPreco.Ata.AditivoApostila.Criar',
	aditivoApostilaEditar: 'AtaRegistroPreco.Ata.AditivoApostila.Editar',
	aditivoApostilaSalvar: 'AtaRegistroPreco.Ata.AditivoApostila.Salvar',
	aditivoApostilaEfetivar: 'AtaRegistroPreco.Ata.AditivoApostila.Efetivar',
	aditivoApostilaAcrescimoSupressao: 'AtaRegistroPreco.Ata.AditivoApostila.AcrescimoSupressao',
	aditivoApostilaCancelarAcrescimoSupressao: 'AtaRegistroPreco.Ata.AditivoApostila.CancelarAcrescimoSupressao',
	aditivoApostilaHistorico: 'AtaRegistroPreco.Ata.AditivoApostila.Historico',
	itemAditivoApostilaExcluir: 'AtaRegistroPreco.Ata.AditivoApostila.Item.Excluir',
	itemAditivoApostilaCancelarDescancelar: 'AtaRegistroPreco.Ata.AditivoApostila.Item.CancelarDescancelar',
	fiscaisMenu: 'AtaRegistroPreco.Fiscais.Menu',
	fiscaisListar: 'AtaRegistroPreco.Fiscais.Listar',
	fiscaisCriar: 'AtaRegistroPreco.Fiscais.Criar',
	fiscaisEditar: 'AtaRegistroPreco.Fiscais.Editar',
	fiscaisBaixar: 'AtaRegistroPreco.Fiscais.Baixar',
	fiscaisExcluir: 'AtaRegistroPreco.Fiscais.Excluir',
	painelPersinalizadoMenu: 'AtaRegistroPreco.Painel.Personalizado.Menu',
	painelMenu: 'AtaRegistroPreco.Painel.Menu',
	revisoesListar: 'AtaRegistroPreco.Revisao.Listar',
	revisoesCriar: 'AtaRegistroPreco.Revisao.Criar',
	revisoesEditar: 'AtaRegistroPreco.Revisao.Editar',
	revisoesExcluir: 'AtaRegistroPreco.Revisao.Excluir',
	revisoesVisualizar: 'AtaRegistroPreco.Revisao.Visualizar',
}
